var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Actions, Effect, ofType } from '@ngrx/effects';
import { map, switchMap, tap, withLatestFrom } from 'rxjs/operators';
import { CHANGE_WEBHOOK_ACTIVITY, ChangeWebhookActivitySuccessAction, DELETE_WEBHOOK, DELETE_WEBHOOK_SUCCESS, DeleteWebhookSuccessAction, GET_ALL_WEBHOOKS, GET_ALL_WEBHOOKS_SUCCESS, GET_MSISDNS_FOR_WEBHOOKS, GET_SINGLE_WEBHOOK, GET_WEBHOOK_TYPES, GetAllWebhooksSuccessAction, GetMsisdnsForWebhooksSuccessAction, GetSingleWebhookSuccessAction, GetWebhookTypesSuccessAction, SAVE_WEBHOOK, SAVE_WEBHOOK_SUCCESS, SaveWebhookSuccessAction, UPDATE_WEBHOOK, UPDATE_WEBHOOK_SUCCESS, UpdateWebhookSuccessAction } from 'app/webhooks/webhooks.actions';
import { WebhooksService } from 'app/webhooks/webhooks.service';
import { MsisdnService } from 'app/shared/msisdn/msisdn.service';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { getWebhookListSelector } from 'app/webhooks/webhooks.reducer';
import { Ng1ModalService } from '../shared/ng1/ng1-modal.service';
import { EMPTY } from 'rxjs';
var WebhooksEffects = /** @class */ (function () {
    function WebhooksEffects(actions$, router, webhooksService, msisdnService, store, ng1ModalService) {
        var _this = this;
        this.actions$ = actions$;
        this.router = router;
        this.webhooksService = webhooksService;
        this.msisdnService = msisdnService;
        this.store = store;
        this.ng1ModalService = ng1ModalService;
        this.getAllWebhooks = this.actions$.pipe(ofType(GET_ALL_WEBHOOKS), switchMap(function () { return _this.webhooksService.getAll().pipe(map(function (response) { return new GetAllWebhooksSuccessAction(response); })); }));
        this.redirectToCreatorIfNoWebhooks = this.actions$.pipe(ofType(GET_ALL_WEBHOOKS_SUCCESS, DELETE_WEBHOOK_SUCCESS), withLatestFrom(this.store.select(getWebhookListSelector)), tap(function (_a) {
            var _ = _a[0], webhooks = _a[1];
            if (!webhooks.length) {
                _this.router.navigateByUrl('/webhooks/new');
            }
        }));
        this.getMsisdnsForWebhooks = this.actions$.pipe(ofType(GET_MSISDNS_FOR_WEBHOOKS), switchMap(function () {
            return _this.msisdnService.inboundableMsisdns().pipe(map(function (response) { return new GetMsisdnsForWebhooksSuccessAction(response); }));
        }));
        this.getWebhookTypes = this.actions$.pipe(ofType(GET_WEBHOOK_TYPES), switchMap(function () { return _this.webhooksService.getTypes().pipe(map(function (response) { return new GetWebhookTypesSuccessAction(response); })); }));
        this.getSingleWebhook = this.actions$.pipe(ofType(GET_SINGLE_WEBHOOK), map(function (action) { return action.payload; }), switchMap(function (id) {
            return _this.webhooksService.getSingle(id).pipe(map(function (response) { return new GetSingleWebhookSuccessAction(response); }));
        }));
        this.saveWebhook = this.actions$.pipe(ofType(SAVE_WEBHOOK), map(function (action) { return action.payload; }), switchMap(function (webhook) {
            return _this.webhooksService.checkIfLimitsExceeded().switchMap(function (_a) {
                var limitsExceeded = _a.limitsExceeded;
                if (limitsExceeded) {
                    _this.ng1ModalService.lazyModalService.showUpgradeAccountModal();
                    return EMPTY;
                }
                return _this.webhooksService.saveWebhook(webhook).pipe(map(function () { return new SaveWebhookSuccessAction(); }));
            });
        }));
        this.updateWebhook = this.actions$.pipe(ofType(UPDATE_WEBHOOK), map(function (action) { return action.payload; }), switchMap(function (_a) {
            var id = _a.id, webhook = _a.webhook;
            return _this.webhooksService.update(id, webhook).pipe(map(function () { return new UpdateWebhookSuccessAction(); }));
        }));
        this.deleteWebhook = this.actions$.pipe(ofType(DELETE_WEBHOOK), map(function (action) { return action.payload; }), switchMap(function (id) { return _this.webhooksService.delete(id).pipe(map(function () { return new DeleteWebhookSuccessAction(id); })); }));
        this.changeWebhookActivity = this.actions$.pipe(ofType(CHANGE_WEBHOOK_ACTIVITY), map(function (action) { return action.payload; }), switchMap(function (_a) {
            var id = _a.id, isActive = _a.isActive;
            var action = isActive ? _this.webhooksService.activate(id) : _this.webhooksService.deactivate(id);
            return action.pipe(map(function () { return new ChangeWebhookActivitySuccessAction(); }));
        }));
        this.redirectToList = this.actions$.pipe(ofType(SAVE_WEBHOOK_SUCCESS, UPDATE_WEBHOOK_SUCCESS), tap(function () {
            _this.router.navigateByUrl('/webhooks/list');
        }));
    }
    __decorate([
        Effect(),
        __metadata("design:type", Object)
    ], WebhooksEffects.prototype, "getAllWebhooks", void 0);
    __decorate([
        Effect({ dispatch: false }),
        __metadata("design:type", Object)
    ], WebhooksEffects.prototype, "redirectToCreatorIfNoWebhooks", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Object)
    ], WebhooksEffects.prototype, "getMsisdnsForWebhooks", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Object)
    ], WebhooksEffects.prototype, "getWebhookTypes", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Object)
    ], WebhooksEffects.prototype, "getSingleWebhook", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Object)
    ], WebhooksEffects.prototype, "saveWebhook", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Object)
    ], WebhooksEffects.prototype, "updateWebhook", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Object)
    ], WebhooksEffects.prototype, "deleteWebhook", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Object)
    ], WebhooksEffects.prototype, "changeWebhookActivity", void 0);
    __decorate([
        Effect({ dispatch: false }),
        __metadata("design:type", Object)
    ], WebhooksEffects.prototype, "redirectToList", void 0);
    return WebhooksEffects;
}());
export { WebhooksEffects };
